import { useCurrentUserId } from 'modules/Auth/hooks';
import { queryKeys, useQueryTE } from 'utils/react-query';
import { getCreditCardsTE } from 'api/users/creditCards';
import { errorToReactLeft } from 'utils/fp';
import { css, cx } from '@linaria/core';
import { baseTheme, flex } from 'styles/utils';
import { useMemo, useState } from 'react';
import { Select } from 'components/Select';
import { Button } from 'components/ui_library/Button';
import { IconCloseSquare } from 'components/Icons';
import { Spinner } from 'components/Spinner';
import { Link } from 'components/Link';
import Image from 'next/image';
import { CARD_TYPE_ICON_MAPPING } from './CardTypesIconMapping';
type Props = {
  onClose: () => void;
  onConfirm: () => void;
  planAmount: number;
};
type CreditCardOption = {
  value: string;
  name: string;
  content: JSX.Element;
  metaData: CF.API.Users.Card;
} | undefined;
const CreditCard = ({
  card
}: {
  card: CF.API.Users.Card;
}): JSX.Element => {
  return <div className={cx(flex.init, flex.alignItems.center, flex.gap[1])}>
      <Image src={CARD_TYPE_ICON_MAPPING[(card?.brand as keyof typeof CARD_TYPE_ICON_MAPPING)] ?? CARD_TYPE_ICON_MAPPING.DefaultCard} alt={card?.brand} width={40} height={40} />
      <span className="card-number">****{card?.four_digits}</span>
    </div>;
};
const Actions = ({
  onClose,
  onConfirm,
  isConfirmDisable
}: {
  onClose: () => void;
  onConfirm: () => void;
  isConfirmDisable?: boolean;
}) => {
  return <div className="actions">
      <Link data-testid="learn-more" className="price-link" href="https://www.clarifai.com/pricing" target="_blank">
        Learn more about pricing
      </Link>
      <Button variant="secondary" onClick={onClose}>
        Cancel
      </Button>
      <Button variant="primary" onClick={onConfirm} disabled={isConfirmDisable}>
        Confirm
      </Button>
    </div>;
};
const Header = ({
  onClose
}: {
  onClose: () => void;
}) => {
  return <div className={cx(flex.init, flex.justifyContent.between, flex.alignItems.center)}>
      <h1 className="title">Confirm payment method</h1>
      <Button variant="unstyled" onClick={onClose}>
        <IconCloseSquare size={20} />
      </Button>
    </div>;
};
export const PreAuthCardModal = ({
  onClose,
  onConfirm,
  planAmount
}: Props) => {
  const userId = useCurrentUserId();
  const {
    data,
    isFetching
  } = useQueryTE([queryKeys.UserCreditCards, {
    userId
  }], getCreditCardsTE({
    userId
  }, errorToReactLeft));
  const [credit, setCreditCard] = useState<CreditCardOption>();
  const creditCards: CF.API.Users.Card[] = data?._tag === 'Right' && data.right.cards ? data.right.cards : [];
  const options = useMemo(() => {
    const optionForDropdown = creditCards.map(card => ({
      value: card.id,
      name: card.id,
      content: <CreditCard card={card} />,
      metaData: card
    }));
    if (optionForDropdown.length > 0) {
      setCreditCard(optionForDropdown[0]);
    }
    return optionForDropdown;
  }, [creditCards.length]);
  return <div className={container}>
      <Header onClose={onClose} />
      <div className="payment-method">
        {isFetching ? <Spinner /> : <div>
            <label htmlFor="payment-method">
              Payment Method <span className="asterisk">*</span>
            </label>
            {options.length === 0 ? <p className={cx('card-number', 'error')}>No credit cards available. Please add a credit card.</p> : <Select title={<CreditCard card={(credit?.metaData as CF.API.Users.Card)} />} modal onChange={selectedCard => setCreditCard((selectedCard as CreditCardOption))} options={options} />}
          </div>}
      </div>
      <p className="note">
        We will make a Pre-authorization of charge of {planAmount} to checks that the card has sufficient funds to cover transactions. This amount
        will be refunded after 7 days.
      </p>

      <Actions onClose={onClose} onConfirm={onConfirm} isConfirmDisable={options.length === 0} />
    </div>;
};
export const container = "odules__User__components__Settings__Billing__CreditCard__PreAuthCardModal_tsx-container-c1sneso7";

require("./PreAuthCardModal.linaria.module.css!=!../../../../../../node_modules/@linaria/webpack-loader/node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js!./PreAuthCardModal.tsx");